










































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { DiscountCodeConsumeRequest } from '@/models/DiscountCode';
import SingleSelect from '@/components/SingleSelect.vue';
import { websiteText } from '@/mixins/websiteTexts';

declare var grecaptcha: any;

@Component({
    components: {
        SingleSelect
    }
})
export default class DiscountCodeConsume extends Vue {
    [x: string]: any;
    isLoaded: boolean = false;
    isLoading: boolean = false;
    discountConsumeResponse: boolean = false;
    code = '';
    orderNumber = '';
    concentPolicy: boolean = true;
    concentPolicyMissing: boolean = false;
    errorMsgs: string[] = [];
    recaptchaString: string;

    errors: { [key: string]: boolean } = {
        orderNumber: false
    };

    constructor() {
        super();
        this.recaptchaString = this.$attrs['data-recaptcha-site-key'];
        this.code = this.$attrs['data-code'];
        this.$attrs['data-recaptcha-site-key'] = '';
        this.$attrs['data-code'] = '';
    }

    clearError(fieldName: string) {
        this.errors[fieldName] = false;
    }

    submitForm() {
        if (this.isLoading) return;
        this.errorMsgs = [];
        const recaptchaSiteKey = this.recaptchaString; //(window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm() || this.isLoading) {
            return;
        } else {
            this.isLoading = true;
            const submit = this.submit;
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then(function(token: string) {
                        submit(token);
                    });
            });
        }
    }

    submit(token: string) {
        const request: DiscountCodeConsumeRequest = {
            token: token,
            orderNumber: this.orderNumber,
            code: this.code
        };

        const requestContext = (window as any).__litium.requestContext;

        axios({
            method: 'post',
            url: `/api/discountcode/consume`,
            data: request,
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then((response: any) => {
                this.isLoading = false;

                this.discountConsumeResponse = response.data;

                const self = this;
                setTimeout(function() {
                    self.isLoaded = true;
                }, 600);
            })
            .catch((response: any) => {
                this.isLoading = false;
                // handle error
                // console.log(response);
            });
    }

    validateForm(): boolean {
        var returnValue = true;

        if (this.orderNumber == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingordernumber'));
            this.errors['orderNumber'] = true;
            returnValue = false;
        }

        return returnValue;
    }
}
